export const LOGIN = '/login';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const EMAIL_LISTS = '/emails_lists';
export const REPORTS = '/reports';
export const MESSAGES = '/messages';
export const USERS = '/users';
export const DASHBOARD = '/';
export const DEFAULT = DASHBOARD;
